import {EnrichmentData, GIScoresData} from "../types/list";
import {apiGetUrl} from "../utils/request";

function createDownloadHook<T>(
  endpoint: string,
  defaultFilename = "TheCellMap_Human_download.xlsx"
) {
  return () => {
    return (data: T, filename?: string) => {
      const url = apiGetUrl(endpoint);

      const options = {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(data),
      };

      return fetch(
        url,
        options
      ).then(async (res) => {
          if (!res.ok) throw new Error(`Download failed: ${res.statusText}`);

          const disposition = res.headers.get("Content-Disposition");
          if (disposition) {
            const match = disposition.match(/filename="?([^";]+)"?/);
            filename = match?.[1] ?? filename;
          }
          const blob = await res.blob();
          const dlUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = dlUrl;
          a.download = filename || defaultFilename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(dlUrl);
        })
        .catch((err) => {
        console.error("Download error:", err);
      });
    };
  };
}

export const usePostScoresDownload = createDownloadHook<GIScoresData>(
  "download_scores",
  "TheCellMap_Human_GI_scores.xlsx"
);

export const usePostEnrichmentDownload = createDownloadHook<EnrichmentData>(
  "enrichment_download",
  "TheCellMap_Human_Enrichment_results.xlsx"
);

export const usePostHeatmapDownload = createDownloadHook<GIScoresData>(
  "download_heatmap",
  "TheCellMap_Human_Interaction_Heatmap.pdf"
);